/**
 * Format a duration in seconds as a compact human string (WP1-67).
 *
 *   formatDuration(0)       -> "0m"
 *   formatDuration(5400)    -> "1h 30m"
 *   formatDuration(180000)  -> "2d 2h"   (minutes dropped once days present)
 *
 * Minutes are omitted once the duration spans days, keeping the label short
 * for cycle-time displays where day-level precision is what matters.
 */
export function formatDuration(seconds: number | null | undefined): string {
  if (seconds == null || seconds <= 0) return '0m'
  const days = Math.floor(seconds / 86400)
  const hours = Math.floor((seconds % 86400) / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)

  const parts: string[] = []
  if (days > 0) parts.push(`${days}d`)
  if (hours > 0) parts.push(`${hours}h`)
  if (minutes > 0 && days === 0) parts.push(`${minutes}m`)

  return parts.length > 0 ? parts.join(' ') : '< 1m'
}
